var map = {
	"./g2.jpg": 66,
	"./g3.jpg": 947,
	"./g4.jpg": 272,
	"./g5.jpg": 453,
	"./g6.jpg": 35,
	"./g7.jpg": 234,
	"./g8.jpg": 74,
	"./g9.jpg": 929
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 693;